import axiosInstance from '@/plugins/axios';

export const actions = {
    async fetchLanguages() {
        try {
            const response = await axiosInstance.get('/api/languages');
            this.languages = response.data?.data ?? response.data ?? [];
            return this.languages;
        } catch (error) {
            console.error('Error fetching languages:', error);
            throw error;
        }
    },
};
